import { render, staticRenderFns } from "./ResourceView2.vue?vue&type=template&id=f2510720"
import script from "./ResourceView2.vue?vue&type=script&lang=js"
export * from "./ResourceView2.vue?vue&type=script&lang=js"
import style0 from "./ResourceView2.vue?vue&type=style&index=0&id=f2510720&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports